import styled from 'styled-components';

const ColumnFilterTitle = styled.div`
  line-height: initial;
`;

export default ColumnFilterTitle;
